module.exports = require("js-sha256");